// extracted by mini-css-extract-plugin
export default {"root":"styles__root--GHNRV","toggle":"styles__toggle--jaCue"};